export const BASE_URL = "https://medsov.com";
